import React, { useMemo } from 'react';
import { SideBar, Viewer } from './components';
import { ThemeProvider } from '@slope/uikit';
import { Layout } from './components/Layout';
import { createStore, StoreProvider } from '@slope/store';
import { Leva } from 'leva';
import * as THREE from 'three';

export type AppProps = object;

export const App: React.FC<AppProps> = () => {
  const store = useMemo(
    () =>
      createStore({
        origin: { lat: 0, lng: 0 }, // Default origin, can be updated later
        scene: new THREE.Object3D(),
        controls: null,
        selection: [],
      }),
    [],
  );

  return (
    <StoreProvider store={store}>
      <ThemeProvider>
        <Layout style={{ position: 'absolute', inset: 0, zIndex: 1 }} sidebar={<SideBar />}>
          <Viewer />
        </Layout>
        <Leva collapsed />
      </ThemeProvider>
    </StoreProvider>
  );
};

export default App;
